// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { configureStore, createSlice } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import interviewHostReducer from './interviewHostSlice';
import jobManagementReducer from './jobManagementSlice';

const authSlice = createSlice({
  name: 'auth',
  initialState: { user: undefined as { name?: string; username?: string } | undefined },
  reducers: {
    setRecruiter: (state, action) => {
      state.user = action.payload;
    },
    clearRecruiter: (state) => {
      state.user = undefined;
    }
  }
});

const agentsSlice = createSlice({
  name: 'agents',
  initialState: { data: [] as Array<{ user_id?: number }> },
  reducers: {}
});

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    agents: agentsSlice.reducer,
    interviewHost: interviewHostReducer,
    jobManagement: jobManagementReducer
  }
});

export const { setRecruiter, clearRecruiter } = authSlice.actions;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
